import script from "./LocationCouplingPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./LocationCouplingPopup.vue?vue&type=script&setup=true&lang=ts"

import "./LocationCouplingPopup.vue?vue&type=style&index=0&id=7c07741d&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\digi_aj\\source\\repos\\1ANAB_Vue_Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c07741d"]])

export default __exports__